import { translate } from '@/i18n/i18nConfig';
import { showGlobalSnackbar } from '@/providers/SnackbarProvider';
import { useAppMutation } from './useAppMutation';

interface SendCourseReminderPayload {
  employeeId: string;
  courseId: string;
  /** Optional custom note included in the reminder email. */
  message?: string;
}

export const useSendCourseReminder = (options?: { onSuccess?: () => void }) => {
  return useAppMutation<unknown, Error, SendCourseReminderPayload>(
    'post',
    '/TrainingManager/courses/remind',
    {
      onSuccess: () => {
        showGlobalSnackbar(translate('manage.courseStudents.reminderSent'), 'success');
        options?.onSuccess?.();
      },
      onError: (error) => {
        const serverMessage = (error as any)?.response?.data?.errorMessage;
        showGlobalSnackbar(
          serverMessage || translate('manage.courseStudents.reminderFailed'),
          'error'
        );
      },
    }
  );
};
